import { useMediaQuery } from 'react-responsive';

export default function RenderOnTablet({
  children,
}) {
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return isMobile ? null : children;
}
